(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHero(root) {
    var hero = root.querySelector('[data-lc-cg-hero]');
    if (!hero || root.dataset.animations === 'false') {
      root.classList.add('is-hero-ready');
      return;
    }
    if (prefersReducedMotion()) {
      root.classList.add('is-hero-ready');
      return;
    }
    window.requestAnimationFrame(function () {
      root.classList.add('is-hero-ready');
    });
  }

  function initParallax(root) {
    if (root.dataset.animations === 'false' || prefersReducedMotion()) return;
    var layer = root.querySelector('[data-lc-cg-parallax]');
    if (!layer) return;

    var ticking = false;
    function update() {
      ticking = false;
      var rect = root.querySelector('[data-lc-cg-hero]').getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var offset = (window.scrollY - root.offsetTop) * 0.08;
      layer.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function initSparkles(root) {
    if (root.dataset.animations === 'false' || prefersReducedMotion()) return;
    var wrap = root.querySelector('[data-lc-cg-sparkles]');
    if (!wrap) return;

    var count = 10;
    for (var i = 0; i < count; i += 1) {
      var dot = document.createElement('span');
      dot.className = 'lc-cg__sparkle';
      dot.style.left = 8 + Math.random() * 84 + '%';
      dot.style.top = 10 + Math.random() * 75 + '%';
      dot.style.opacity = String(0.15 + Math.random() * 0.25);
      wrap.appendChild(dot);

      (function (el, delay) {
        var dir = Math.random() > 0.5 ? 1 : -1;
        var amp = 6 + Math.random() * 10;
        var start = performance.now() + delay;

        function tick(now) {
          var t = (now - start) / 1000;
          var y = Math.sin(t * 0.9) * amp;
          var x = Math.cos(t * 0.7) * amp * 0.35 * dir;
          el.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
          window.requestAnimationFrame(tick);
        }
        window.requestAnimationFrame(tick);
      })(dot, i * 120);
    }
  }

  function initTiles(root) {
    var tiles = root.querySelectorAll('[data-lc-cg-tile]');
    if (!tiles.length) return;

    if (root.dataset.animations === 'false' || prefersReducedMotion()) {
      tiles.forEach(function (tile) {
        tile.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      tiles.forEach(function (tile) {
        tile.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var tile = entry.target;
          var index = Number(tile.getAttribute('data-lc-cg-index')) || 0;
          window.setTimeout(function () {
            tile.classList.add('is-visible');
          }, index * 90);
          observer.unobserve(tile);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    tiles.forEach(function (tile) {
      observer.observe(tile);
    });
  }

  function init(root) {
    if (!root || root.dataset.lcCgInit === 'true') return;
    root.dataset.lcCgInit = 'true';
    initHero(root);
    initSparkles(root);
    initParallax(root);
    initTiles(root);
  }

  function boot() {
    document.querySelectorAll('[data-lc-cg]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-lc-cg]');
    if (root) init(root);
  });
})();
